<template>
  <v-progress-circular v-if="!$store.state.loaded" indeterminate></v-progress-circular>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    v-else
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="$store.state.fireUser" icon v-on="on">
        <v-avatar
          size="32"
          v-if="$store.state.fireUser.photoURL"
        >
          <v-img :src="$store.state.fireUser.photoURL" alt="avatar"></v-img>
        </v-avatar>
        <v-btn v-else icon v-on="on">
          <v-icon>mdi-lock-open</v-icon>
        </v-btn>
      </v-btn>
      <v-btn v-else icon v-on="on">
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>
    <v-card v-if="$store.state.fireUser">
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-img v-if="$store.state.fireUser.photoURL" :src="$store.state.fireUser.photoURL" alt="avatar"></v-img>
            <v-icon v-else>mdi-lock-open</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="$store.state.fireUser.displayName"></v-list-item-title>
            <v-list-item-subtitle v-text="$store.state.fireUser.email"></v-list-item-subtitle>
          </v-list-item-content>

        </v-list-item>
        <v-divider/>
        <v-list-item>
          <v-list-item-action>
            <v-switch v-model="editable" @change="changeEdit"></v-switch>
          </v-list-item-action>
          <v-list-item-title>수정모드</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-btn @click="saveDefault" icon><v-icon>mdi-content-save</v-icon></v-btn>
          </v-list-item-action>
          <v-list-item-title>기본값 설정(관리자 기능)</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-btn @click="saveDefaultAll" icon><v-icon>mdi-content-save</v-icon></v-btn>
          </v-list-item-action>
          <v-list-item-title>전체 메뉴 초기화(관리자 기능)</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item>
          <v-list-item-action>
            <v-btn @click="cloneSite" icon><v-icon>mdi-content-save</v-icon></v-btn>
          </v-list-item-action>
          <v-list-item-title>기본값 설정</v-list-item-title>
        </v-list-item> -->
      </v-list>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="restoreSite" color="warning">초기화</v-btn>
        <v-btn color="primary" @click="signOut">
          로그아웃
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else max-width="200">
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <v-card-title v-on="on">로그인</v-card-title>
        </template>
        <span>로그인을 하면 글 작성및 게시물 테스트가 가능합니다.</span>
      </v-tooltip>
      <v-divider/>
      <v-form>
        <v-subheader>이메일 로그인</v-subheader>
        <v-card-text>
          <v-text-field v-model="email" outlined label="이메일" hide-details class="mb-4"></v-text-field>
          <v-text-field v-model="password" type="password" outlined label="비밀번호" hide-details></v-text-field>
        </v-card-text>
        <v-card-actions >
          <v-btn color="accent" @click="signInWithEmail" dark block>
            <v-icon left>mdi-email</v-icon>
            <span>로그인</span>
          </v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="secondary" @click="signUpWithEmail" dark block v-bind="attrs" v-on="on">
                <v-icon left>mdi-account-plus</v-icon>
                회원가입
              </v-btn>
            </template>
            <span>회원가입시 이메일 외에 그 어떤 개인정보도 수집하지 않습니다</span>
          </v-tooltip>
        </v-card-actions>
        <v-card-title class="caption">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text color="primary" v-bind="attrs" v-on="on">비밀번호를 잊으셨나요?</v-btn>
            </template>
            <span>클릭시 비밀번호 초기화 메일이 전송됩니다</span>
          </v-tooltip>
        </v-card-title>
      </v-form>
      <v-divider/>
      <v-subheader>혹은 소셜로그인</v-subheader>
      <v-card-actions>
        <v-btn color="error" @click="signInWithGoogle" dark block>
          <v-icon left>mdi-google</v-icon>
          구글 로그인
        </v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-btn color="primary" @click="signInWithFacebook" block>
          <v-icon left>mdi-facebook</v-icon>
          페이스북 로그인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: ['site'],
  data () {
    return {
      menu: false,
      loading: false,
      editable: false,
      email: '',
      password: ''
    }
  },
  created () {
    this.$firebase.auth().languageCode = 'ko'
    // console.log(this.$store.state.fireUser.photoURL)
  },
  destroyed () {
  },
  methods: {
    async signInWithEmail () {
      if (!this.email || !this.password) throw Error('이메일, 비밀번호를 입력하세요')
      this.loading = true
      try {
        await this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password)
      } finally {
        this.loading = false
        this.menu = false
      }
    },
    async signUpWithEmail () {
      if (!this.email || !this.password) throw Error('이메일, 비밀번호를 입력하세요')
      this.loading = true
      try {
        const sn = await this.$firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        await sn.user.sendEmailVerification()
        this.$toast.success('가입이 완료되었습니다. 이메일을 확인해주세요')
      } finally {
        this.loading = false
        this.menu = false
      }
    },
    async signInWithGoogle () {
      this.loading = true
      const provider = new this.$firebase.auth.GoogleAuthProvider()

      try {
        await this.$firebase.auth().signInWithPopup(provider)
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        // this.changeEdit(true)
        this.loading = false
        this.menu = false
      }
    },
    async signInWithFacebook () {
      this.$toast.info('준비중입니다')
    },
    signOut () {
      this.changeEdit(false)
      this.$firebase.auth().signOut()
      this.menu = false
    },
    changeEdit (v) {
      this.$store.commit('setEditable', v)
    },
    cloneSite () {
      this.$firebase.database().ref().child('sites').child('default').once('value', (sn) => {
        this.$firebase.database().ref().child('sites').child(this.$store.state.fireUser.uid).set(sn.val())
      })
    },
    async restoreSite () {
      const r = await this.$swal.fire({
        title: '정말 초기화 하시겠습니까?',
        text: '초기화 후 되돌릴 수 없습니다.',
        icon: 'warning',
        showCancelButton: true
      })
      if (!r.value) return
      const sn = await this.$firebase.database().ref().child('sites').child('default').once('value')
      const site = sn.val()
      site.title = this.$store.state.fireUser.displayName + ' 사이트'
      site.footer = '2020 ' + this.$store.state.fireUser.email.split('@')[0]
      this.$firebase.database().ref().child('sites').child(this.$store.state.fireUser.uid).set(site)
      // this.$firebase.database().ref().child('sites').child(this.$store.state.fireUser.uid).set({
      //   title: this.$store.state.fireUser.displayName + ' 사이트',
      //   banner: 'Vue & Firebase Test 계정입니다. 데이터 삭제되도 슬퍼말아요~',
      //   footer: '2020 ' + this.$store.state.fireUser.email.split('@')[0],
      //   menu: [
      //     {
      //       title: '메인',
      //       icon: 'mdi-home',
      //       active: true,
      //       subItems: [
      //         {
      //           title: '시작',
      //           to: '/'
      //         }
      //       ]
      //     }
      //   ]
      // })
    },
    async saveDefault () {
      const r = await this.$swal.fire({
        title: '정말 기본값으로 변경 하시겠습니까?',
        text: '이후 비로그인 화면 구성이 현재 화면이 됩니다.',
        icon: 'warning',
        showCancelButton: true
      })
      if (!r.value) return
      this.site.uid = this.$store.state.fireUser.uid
      try {
        this.$firebase.database().ref().child('sites').child('default').set(this.site)
      } catch (e) {
        this.$toast.error('관리자만 사용 가능한 기능입니다')
      }
    },
    async saveDefaultAll () {
      const r = await this.$swal.fire({
        title: '정말 모두 기본값으로 변경 하시겠습니까?',
        text: '이후 모든 로그인 화면 구성이 현재 화면이 됩니다.',
        icon: 'error',
        showCancelButton: true
      })
      if (!r.value) return
      this.site.uid = this.$store.state.fireUser.uid
      try {
        const sn = await this.$firebase.database().ref().child('sites').once('value')
        const sites = sn.val()
        for (const k in sites) {
          if (k === 'default') continue
          await this.$firebase.database().ref().child('sites').child(k).child('menu').set(sites.default.menu)
          await this.$firebase.database().ref().child('sites').child(k).child('banner').set(sites.default.banner)
        }
      } catch (e) {
        this.$toast.error('관리자만 사용 가능한 기능입니다')
      }
    }
  }
}
</script>
